import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { mockData } from '../mock';

export const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    <section id="about" className="relative py-32 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-10" />
      
      <motion.div
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.1, 0.15, 0.1]
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-20 right-10 w-[600px] h-[600px] bg-amber-500 rounded-full blur-[150px]"
      />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Main Title */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-7xl font-bold text-white mb-16 text-center leading-tight"
        >
          {mockData.about.title}
        </motion.h2>

        {/* Paragraphs */}
        <div className="max-w-4xl mx-auto space-y-8 mb-20">
          {mockData.about.paragraphs.map((paragraph, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 + i * 0.1 }}
              className="text-lg md:text-xl text-slate-300 leading-relaxed"
            >
              {paragraph}
            </motion.p>
          ))}
        </div>

        {/* Principles - Three Pillars */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto"
        >
          {mockData.about.principles.map((principle, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.7 + i * 0.15 }}
              whileHover={{ y: -10 }}
              className="group relative p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl hover:border-amber-400/50 transition-all duration-500 overflow-hidden"
            >
              {/* Hover Gradient Background */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/0 to-amber-400/0 group-hover:from-amber-400/10 group-hover:to-transparent transition-all duration-500" />
              
              <div className="relative z-10">
                <div className="text-6xl font-bold text-amber-400 mb-4">0{i + 1}</div>
                <h3 className="text-2xl font-bold text-white mb-3">{principle.title}</h3>
                <p className="text-slate-400 leading-relaxed">{principle.description}</p>
              </div>

              {/* Corner Accent */}
              <motion.div
                className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-amber-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{ borderRadius: '0 1.5rem 0 100%' }}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
